import React, { useState, useEffect, useRef, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { DataTable } from "primereact/datatable";
import {
  Column,
  Toast,
  TabView,
  TabPanel,
  Button,
  Dialog,
  Card,
  InputText,
  InputTextarea,
  Dropdown,
  ProgressSpinner,
  RadioButton,
} from "primereact";
import Moment from "moment";
import ReactGA from "react-ga4";
import Costanti from "../constantiX";
import { Chart } from "primereact/chart";
import Supporto from "./Supporto";

import { FormattedMessage } from "react-intl";

class DashBoard extends React.Component {
  constructor() {
    super();

    this.actions = [
      {
        id: 1,
        icon: "pi-search",
        label: "",
        action: (idx) => {
          this.vai(idx);
        },
      },
    ];
    this.anno = [
      { name: "2022", code: "2022" },
      { name: "2023", code: "2023" },
    ];

    this.state = {
      anno: "2023",
      viewdett: false,
      activeIndex: 0,
      loading: false,
      dati: [],
      grafici: [],
      activePage: 1,
      totalRecords: 0,
      pageSize: 100,
      first: 0,
      visible2: false,
      visible3: false,
      singolo: {},
    };
    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));
    this.onPage = this.onPage.bind(this);
  }

  static context = this.langContext;

  componentDidMount() {
    //ReactGA.send({ hitType: "pageview", page: this.props.location.pathname });
    this.caricaDati(1, this.state.pageSize, this.state.anno);
    this.lingua = this.props.lingua;
    this.cont = this.context;
  }

  search(nome) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };

    this.setState({ loading: true });
    var quer = "ricerca=" + nome + "&page=1&num=" + this.state.pageSize;
    axios
      .get(Costanti.UrlCallApi + "statistica/aziende?" + quer, config)
      .then((res) => {
        this.setState({ dati: res.data.lista1, totalRecords: res.data.conta1, loading: false });

        //alert(JSON.stringify(this.state.dati))
      })
      .catch((error) => {
        alert(error);
        this.setState({ loading: false });
      });
  }

  caricaDati(pagina, numrec, anno) {
    //    alert(JSON.stringify(en));
    //this.setState({lingua:en});

    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    var quer = "page=" + pagina + "&num=" + numrec;
    axios
      .get(Costanti.UrlCallApi + "statistica/aziende?" + quer, config)
      .then((res) => {
        this.setState({ dati: res.data.lista1, totalRecords: res.data.conta1, loading: false });

        //alert(JSON.stringify(this.state.dati))
      })
      .catch((error) => {
        // alert(error)
      });
    axios
      .get(Costanti.UrlCallApi + "statistica/grafici?anno=" + anno, config)
      .then((res) => {
        this.setState({ grafici: res.data, loading: false });
        this.setState({
          chartData: {
            labels: ["Agroalimentare", "Tessile"],
            datasets: [
              {
                data: [this.state.grafici.con1, this.state.grafici.con2],
                backgroundColor: ["#42A5F5", "#66BB6A"],
                hoverBackgroundColor: ["#64B5F6", "#81C784"],
              },
            ],
          },
        });

        this.setState({
          chartDataU1: {
            labels: ["Admin", "NoAdmin"],
            datasets: [
              {
                data: this.state.grafici.elementiU1,
                backgroundColor: ["#42A5F5", "#66BB6A"],
                hoverBackgroundColor: ["#64B5F6", "#81C784"],
              },
            ],
          },
        });

        this.setState({
          chartDataU2: {
            labels: ["Admin", "NoAdmin"],
            datasets: [
              {
                data: this.state.grafici.elementiU2,
                backgroundColor: ["#42A5F5", "#66BB6A"],
                hoverBackgroundColor: ["#64B5F6", "#81C784"],
              },
            ],
          },
        });

        this.setState({
          chartDataU3: {
            labels: ["Admin", "NoAdmin"],
            datasets: [
              {
                data: this.state.grafici.elementiU3,
                backgroundColor: ["#42A5F5", "#66BB6A"],
                hoverBackgroundColor: ["#64B5F6", "#81C784"],
              },
            ],
          },
        });

        this.setState({
          basicData: {
            labels: [
              "Gennaio",
              "Febbraio",
              "Marzo",
              "Aprile",
              "Maggio",
              "Giugno",
              "Luglio",
              "Agosto",
              "Settembre",
              "Ottobre",
              "Novembre",
              "Dicembre",
            ],
            datasets: [
              {
                label: "Censimento Utenti",
                data: this.state.grafici.elementiA1,
                fill: false,
                borderColor: "#42A5F5",
                tension: 0.4,
              },
              {
                label: "Creazione Prodotti",
                data: this.state.grafici.elementiA2,
                fill: false,
                borderColor: "#FFA726",
                tension: 0.4,
              },
              {
                label: "Modifica Prodotti",
                data: this.state.grafici.elementiA3,
                fill: false,
                borderColor: "#FF11A7",
                tension: 0.4,
              },
            ],
          },
        });

        this.setState({
          basicData2: {
            labels: [
              "Gennaio",
              "Febbraio",
              "Marzo",
              "Aprile",
              "Maggio",
              "Giugno",
              "Luglio",
              "Agosto",
              "Settembre",
              "Ottobre",
              "Novembre",
              "Dicembre",
            ],

            datasets: [
              {
                label: "Agroalimentare",
                data: this.state.grafici.elementiN1,
                backgroundColor: "#42A5F5",
              },
              {
                label: "Tessile",
                data: this.state.grafici.elementiN2,
                backgroundColor: "#FFA726",
              },
            ],
          },
        });
      })
      .catch((error) => {
        alert(error);
      });
  }

  onPage(event) {
    this.setState({
      loading: true,
      activePage: event.page + 1,
      first: event.first,
    });
    this.caricaDati(event.page + 1, this.state.pageSize, this.state.anno);
  }

  lightOptions = {
    plugins: {
      legend: {
        labels: {
          color: "#495057",
        },
      },
    },
  };

  horizontalOptions = {
    indexAxis: "y",
    maintainAspectRatio: false,
    aspectRatio: 0.8,
    plugins: {
      legend: {
        labels: {
          color: "#495057",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#495057",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#495057",
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  caricaSingolo(id) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    axios
      .get(Costanti.UrlCallApi + "azienda/" + id, config)
      .then((res) => {
        this.setState({ singolo: res.data, loading: false });
        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
      });
  }
  vai(id, tipo) {
    this.caricaSingolo(id);
    this.setState({ viewdett: true });
  }
  setAnno(e) {
    this.setState({ anno: e });

    this.caricaDati(1, this.state.pageSize, e);
  }

  setEsporta(value) {
    this.setState({ loading: true });
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .get(Costanti.UrlCallApi + "stampe/xlsStat", config)
      .then((res) => {
        const link = document.createElement("a");
        const url = Costanti.UrlCallApi + "file/getFile/" + res.data;

        link.href = url;
        link.setAttribute("download", res.data);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        this.showMessage("error", "Errore nella stampa", error.message);
        this.setState({ isSubmitting: false });
      });

    this.setState({ loading: false });
  }

  setPDF(value) {
    this.setState({ loading: true });
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .get(Costanti.UrlCallApi + "stampe/pdfStat", config)
      .then((res) => {
        const link = document.createElement("a");
        const url = Costanti.UrlCallApi + "file/getFile/" + res.data;

        link.href = url;
        link.setAttribute("download", res.data);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        this.showMessage("error", "Errore nella stampa", error.message);
        this.setState({ isSubmitting: false });
      });

    this.setState({ loading: false });
  }

  render() {
    return (
      <div className="flex flex-column">
        {this.state.loading ? <ProgressSpinner /> : ""}
        <Dialog
          header="Dettaglio Azienda"
          closable={false}
          visible={this.state.viewdett}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ maxWidth: "70vw" }}
          draggable={false}
          resizable={false}
        >
          <div className="flex flex-wrap border-top-1 surface-border pt-4">
            <div className="surface-card p-2  border-round">
              <div className="text-600 font-medium text-600 text-xl mb-3">Dati Identificativi Azienda</div>
              <div className="surface-card p-2  border-round">
                <div className="grid formgrid p-fluid">
                  <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

                  <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="ragionesociale" className="font-medium text-600">
                      Ragione Sociale
                    </label>
                    <InputText
                      name="ragionesociale"
                      readOnly={true}
                      value={this.state.singolo.ragionesociale}
                      type="text"
                    />
                  </div>
                  <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="sede" className="font-medium text-600">
                      Sede Principale
                    </label>
                    <InputText type="text" name="sede" readOnly={true} value={this.state.singolo.sede} />
                  </div>
                  <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="partitaiva" className="font-medium text-600">
                      Partita Iva
                    </label>
                    <InputText name="partitaiva" readOnly={true} type="text" value={this.state.singolo.partitaiva} />
                  </div>
                  <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="telefono" className="font-medium text-600">
                      Telefono
                    </label>
                    <InputText type="text" readOnly={true} name="telefono" value={this.state.singolo.telefono} />
                  </div>
                  <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="email" className="font-medium text-600">
                      Email
                    </label>
                    <InputText type="email" readOnly={true} name="email" value={this.state.singolo.email} />
                  </div>
                  <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="pec" className="font-medium text-600">
                      Pec
                    </label>
                    <InputText type="email" readOnly={true} name="pec" value={this.state.singolo.pec} />
                  </div>
                  <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="sitoweb" className="font-medium text-600">
                      Sito Web
                    </label>
                    <div className="p-inputgroup">
                      <span className="p-inputgroup-addon">www</span>
                      <InputText type="text" readOnly={true} name="sitoweb" value={this.state.singolo.sitoweb} />
                    </div>
                    <label htmlFor="avatar2" className="font-medium text-600">
                      Logo Azienda
                    </label>
                    <div className="flex align-items-center">
                      <img
                        src={
                          Costanti.UrlCallApi + "file/get/" + this.state.singolo.id + "/logo/" + this.state.singolo.id
                        }
                        width="30%"
                        alt="Immagine logo"
                        className="mr-4"
                      />
                    </div>
                  </div>

                  <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="info" className="font-medium text-600">
                      Note Aggiuntive
                    </label>
                    <InputTextarea
                      id="info"
                      readOnly={true}
                      type="text"
                      rows={10}
                      autoResize
                      value={this.state.singolo.info}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button
                type="button"
                icon="pi pi-check"
                onClick={() => this.setState({ viewdett: false })}
                label="Chiudi"
              />
            </div>
          </footer>
        </Dialog>

        {this.token ? (
          <div>
            <TabView
              activeIndex={this.state.activeIndex}
              onTabChange={(e) => {
                this.setState({ activeIndex: e.index });
              }}
            >
              {sessionStorage.getItem("ruoloid") != null && sessionStorage.getItem("ruoloid") <= 2 ? (
                <TabPanel header="Aziende">
                  <DataTable
                    value={this.state.dati}
                    rows={this.state.pageSize}
                    totalRecords={this.state.totalRecords}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="	(pag. {currentPage} di {totalPages}) "
                    paginator={true}
                    onPage={this.onPage}
                    loading={this.state.loading}
                    lazy={true}
                    first={this.state.first}
                    header={
                      <div className="mb-1 flex align-items-center justify-content-between">
                        <span className="text-xl font-medium text-900">Lista Aziende</span>

                
                        <Button
                          label="Esporta in Pdf"
                          onClick={() => this.setPDF(true)}
                          loading={this.state.loading}
                          disabled={this.state.loading}
                          icon="pi pi-file-pdf"
                          className="p-button-rounded p-button-danger "
                        />
                      </div>
                    }
                    responsiveLayout="stack"
                  >
                    <Column id="id1" field="ragionesociale" header="Ragione Sociale" />
                    <Column id="id2" field="status" header="Status" />
                    <Column id="id3" field="tipo" header="Tipo" />
                    <Column id="id4" field="nrNotariz" header="Notarizzazione Effettuate" />
                    <Column
                      id="id5"
                      field="id"
                      header=""
                      body={(item) => (
                        <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                          {this.actions.map((action) => (
                            <Button
                              key={action.id}
                              className="p-button-sm"
                              icon={`pi ${action.icon}`}
                              label={action.label}
                              aria-label={action.label}
                              onClick={(e) => {
                                e.stopPropagation();
                                action.action(item.id);
                              }}
                            />
                          ))}
                        </div>
                      )}
                    ></Column>
                  </DataTable>
                </TabPanel>
              ) : (
                ""
              )}

              {sessionStorage.getItem("ruoloid") != null && sessionStorage.getItem("ruoloid") ==999999 ? (
                <TabPanel header="Supporto">
                  <Supporto></Supporto>
                </TabPanel>
              ) : (
                ""
              )}

              {sessionStorage.getItem("ruoloid") != null && sessionStorage.getItem("ruoloid") == 3 ? (
                <TabPanel header="Config">
                  <Config></Config>
                </TabPanel>
              ) : (
                ""
              )}

              <TabPanel header="Statistiche">
                <div className="card flex justify-content-center">
                  <Dropdown
                    value={this.state.anno}
                    options={this.anno}
                    onChange={(e) => this.setAnno(e.value)}
                    optionLabel="name"
                    optionValue="code"
                    placeholder="Seleziona anno"
                  />
                </div>

                <div className="card flex justify-content-center">
                  <div className="col-12 lg:col-4">
                    <div className="surface-card border-round  p-4 ">
                      <div className="text-900 font-medium mb-3 text-xl text-center">Settore Aziende</div>
                      <div className="text-900 font-medium mb-3 text-xl">
                        <table width={"100%"}>
                          <tr>
                            <td>Agroalimentare</td>
                            <td>{this.state.grafici.con1}</td>
                          </tr>
                          <tr>
                            <td>Tessile</td>
                            <td>{this.state.grafici.con2}</td>
                          </tr>
                        </table>
                      </div>
                      <p className="mt-0 mb-4 p-0 line-height-3"></p>
                      <div className="text-900 font-medium mb-3 text-xl text-center">
                        <Chart
                          type="pie"
                          data={this.state.chartData}
                          options={this.lightOptions}
                          style={{ position: "relative", width: "80%" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 lg:col-8">
                    <div className="surface-card border-round  p-4 ">
                      <div className="text-900 font-medium mb-3 text-xl text-center">Attività Aziende</div>

                      <p className="mt-0 mb-4 p-0 line-height-3"></p>
                      <div className="text-900 font-medium mb-3 text-xl text-center">
                        <Chart
                          type="line"
                          data={this.state.basicData}
                          options={this.lightOptions}
                          style={{ position: "relative", width: "80%" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card flex justify-content-center">
                  <div className="col-12 lg:col-6">
                    <div className="surface-card border-round  p-4 ">
                      <div className="text-900 font-medium mb-3 text-xl text-center">Utenti Aziende</div>
                      <div className="text-900 font-medium mb-3 text-xl">
                        <table width={"100%"}>
                          <tr>
                            <td colSpan={"2"}>Agroalimentare</td>
                            <td colSpan={"2"}>Tessile </td>
                          </tr>
                          <tr>
                            <td width={"25%"}>Totali</td>
                            <td>
                              {this.state.grafici.elementiU1
                                ? this.state.grafici.elementiU1[0] + this.state.grafici.elementiU1[1]
                                : ""}
                            </td>
                            <td width={"25%"}>Totali</td>
                            <td>
                              {this.state.grafici.elementiU2
                                ? this.state.grafici.elementiU2[0] + this.state.grafici.elementiU2[1]
                                : ""}
                            </td>
                          </tr>
                          <tr>
                            <td>Admin</td>
                            <td>{this.state.grafici.elementiU1 ? this.state.grafici.elementiU1[0] : ""}</td>
                            <td width={"25%"}>Admin</td>
                            <td>{this.state.grafici.elementiU2 ? this.state.grafici.elementiU2[0] : ""}</td>
                          </tr>
                          <tr>
                            <td>Non admin</td>
                            <td>{this.state.grafici.elementiU1 ? this.state.grafici.elementiU1[1] : ""}</td>
                            <td width={"25%"}>Non admin</td>
                            <td>{this.state.grafici.elementiU2 ? this.state.grafici.elementiU2[1] : ""}</td>
                          </tr>
                        </table>
                      </div>
                      <p className="mt-0 mb-4 p-0 line-height-3"></p>
                      <div class="grid">
                        <div class="col-4">
                          <p className="mt-0 mb-4 p-0 line-height-3 text-center">Agroalimentare</p>
                          <Chart
                            type="pie"
                            data={this.state.chartDataU1}
                            style={{ position: "relative", width: "100%" }}
                          />
                        </div>
                        <div class="col-4">
                          <p className="mt-0 mb-4 p-0 line-height-3 text-center">Tessile</p>
                          <Chart
                            type="pie"
                            data={this.state.chartDataU2}
                            style={{ position: "relative", width: "100%" }}
                          />
                        </div>
                        <div class="col-4">
                          <p className="mt-0 mb-4 p-0 line-height-3 text-center">TUTTI</p>
                          <Chart
                            type="pie"
                            data={this.state.chartDataU3}
                            style={{ position: "relative", width: "100       %" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 lg:col-6">
                    <div className="surface-card border-round  p-4 ">
                      <div className="text-900 font-medium mb-3 text-xl text-center">
                        Notarizzazione effettuate Aziende
                      </div>

                      <p className="mt-0 mb-4 p-0 line-height-3"></p>
                      <div className="text-900 font-medium mb-3 text-xl text-center">
                        <Chart
                          type="bar"
                          data={this.state.basicData2}
                          options={this.horizontalOptions}
                          style={{ position: "relative", width: "80%" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
              {sessionStorage.getItem("ruoloid") != null && sessionStorage.getItem("ruoloid") <= 2 ? (
                <TabPanel header="Analytics">
                  <iframe
                    width="100%"
                    height="500"
                    allowFullScreen={true}
                    src={"https://datastudio.google.com/embed/reporting/" + Costanti.AnalititcsREP}
                  ></iframe>
                </TabPanel>
              ) : (
                ""
              )}
            </TabView>
          </div>
        ) : (
          <div className="grid grid-nogutter">
            <div className="col-12 md:col-12 lg:col-12 p-3 dash1">
              <FormattedMessage id="dash.vetrina" />
            </div>

            <div className="col-12 md:col-12 lg:col-12">
              <div className="dash2">
                <FormattedMessage id="dash.ricerca1" />
                <br />
                <FormattedMessage id="dash.ricerca2" />
              </div>
              <div className="mt-1  text-xl text-center">
                <span className="p-input-icon-right">
                  <InputText
                    type="search"
                    className="w-full"
                    placeholder="Cerca aziende"
                    onChange={(e) => this.search(e.target.value)}
                  />

                  <i className="pi pi-search" />
                </span>
              </div>
            </div>

            {this.state.dati
              ? this.state.dati.map((desc, index) => {
                  return (
                    <div className="col-12 md:col-6 lg:col-4 mb-2 mt-2 p-3">
                      <div className="cardc3  border-round h-full">
                        <div className="mt-5 text-900 font-medium mb-1 text-xl text-center">
                          <img
                            className="card mt-5 w-full"
                            src={Costanti.UrlCallApi + "file/get/" + desc.id + "/logo/" + desc.id}
                            alt=""
                            style={{ maxWidth: "90%", objectFit: "contain", height: "25vh" }}
                          />
                        </div>
                        <div className="dash4 mx-3">{desc.ragionesociale}</div>

                        <div className="col-12 col-12 md:col-12 lg:col-12 p-3"></div>

                        <div className="flex justify-content-between">
                          <div>
                            <div className="flex justify-content-start dash5 ml-3">
                              <i className="pi pi-envelope"> &nbsp;Mail:&nbsp; </i>
                            </div>
                            <div className="flex justify-content-start dash6 ml-3">
                              <span> {desc.email}</span>
                            </div>
                          </div>

                          <div className="flex justify-content-end mx-3">
                            <span>
                              <Link to={"/" + desc.sigla + "/schedaazi/" + desc.id}>
                                <span className="pi pi-angle-right dash3" />
                              </Link>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              : ""}
          </div>
        )}
      </div>
    );
  }
}

export default DashBoard;
